import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TerminalPaymentWaitDialogComponent } from './terminal-payment-wait-dialog.component';
import { TerminalProfileSelectDialogComponent } from './terminal-profile-select-dialog.component';

@NgModule({
  declarations: [TerminalPaymentWaitDialogComponent, TerminalProfileSelectDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  exports: [TerminalPaymentWaitDialogComponent, TerminalProfileSelectDialogComponent]
})
export class TerminalPaymentModule {}
